<template>
	<div class="tab-pane fade" id="specification">
		<div class="specification-whole-container">
			<div
				class="spec-table"
				v-for="spec in selectedProduct.specification_type"
				:key="spec.id"
			>
				<div v-if="spec.specifications.length > 0">
					<h4 class="spec-heading">{{ spec.type }}</h4>
					<table>
						<tr v-for="specification in spec.specifications" :key="specification.id">
							<td>{{ specification.name }}</td>
							<td>{{ specification.detail }}</td>
						</tr>
					</table>
				</div>
			</div>
			<div
				class="product-not-found"
				v-if="selectedProduct.specification_type.length == count"
			>
				<div class="not-found">
					<h2>SORRY!</h2>
					<h6>No Specifications Found.</h6>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {mapActions, mapGetters} from "vuex";
	export default {
		computed: {...mapGetters("products", ["status", "selectedProduct"])},
		data() {
			return {
				count: 0,
			};
		},
		methods: {},
		mounted() {
			//logic	here is to check if the product has specifications or not 
			this.selectedProduct.specification_type.filter((product) => {
				if (product.specifications.length == 0) { // if there is no specification
					this.count = this.count + 1; 
				}
			});
		},
	};
</script>

<style scoped>
	.product-not-found {
		height: 200px;
		min-height: 0px;
	}
</style>
